import { Checkbox } from './Checkbox'
import { CollectionTemplateDefinitionField, CollectionTemplateDefinitionView } from '@indigohive/cogfy-types'
import { CollectionTemplateTableField } from './CollectionTemplateTableField'
import { EllipsisIcon, PlusIcon } from 'lucide-react'

export type CollectionTemplateTableHeadProps = {
  fields: CollectionTemplateDefinitionField[] | undefined
  viewFields: CollectionTemplateDefinitionView['viewFields'] | undefined
  records: string[]
  selectedRecords: string[]
  setSelectedRecords: React.Dispatch<React.SetStateAction<string[]>>
}

export function CollectionTemplateTableHead (props: CollectionTemplateTableHeadProps) {
  const { fields, viewFields, selectedRecords, records, setSelectedRecords } = props

  return (
    <div
      id="table-head"
      className="sticky top-0 inline-flex flex-row items-center min-w-full border-b border-neutral/40 min-h-8 h-8"
    >
      <label className="py-1 px-2 h-full flex items-center">
        <Checkbox
          ref={ref => {
            const someSelected = Object.keys(selectedRecords).length > 0
            const allSelected = Object.keys(selectedRecords).length === records?.length
            const indeterminate = someSelected && !allSelected
            if (ref) {
              ref.indeterminate = indeterminate
            }
          }}
          className="rounded-md"
          size="xs"
          color="info"
          checked={selectedRecords.length > 0}
          onChange={(event: any) => {
            if (event.currentTarget.checked) {
              setSelectedRecords(records.map((_, i) => `row-${i}`))
            } else {
              setSelectedRecords([])
            }
          }}
        />
      </label>
      {viewFields?.map(viewField => (
        <CollectionTemplateTableField
          key={viewField.fieldId}
          field={fields?.find(field => field.id === viewField.fieldId)}
          config={viewField?.config}
        />
      ))}
      <div className="h-full flex py-1 px-2 gap-3 items-center cursor-pointer hover:bg-slate-100">
        <PlusIcon size={13} />
      </div>
      <div className="h-full flex py-1 px-2 gap-3 items-center cursor-pointer hover:bg-slate-100">
        <EllipsisIcon size={13} />
      </div>
    </div>
  )
}
